// extracted by mini-css-extract-plugin
export default {"UploadTextarea":"UploadTextarea_UploadTextarea__dsDI4","errorText":"UploadTextarea_errorText__fg1-D"};